import { NAME_REGEX } from '../constants';

export const isNameValid = (name: string): boolean => {
  return Boolean(name) && (name.match(NAME_REGEX)?.length ?? 0) > 0;
};
